import React from "react";
import "./List.css"

export default function ListView({children, reference}){

    return (
        <div className="list-view" ref={reference}>
            {children}
        </div>
    );
}